import { createBrowserRouter } from 'react-router';
import { AppLayout } from '@/app/layouts/AppLayout';
import { PublicLayout } from '@/app/layouts/PublicLayout';
import { RequireSession } from '@/app/layouts/RequireSession';
import { accountRoutes } from '@/modules/account/account.routing';
import { applicationsRoutes } from '@/modules/applications/applications.routing';
import { cashAndBillingRoutes } from '@/modules/cash-and-billing/cash-and-billing.routing';
import { permitsRoutes } from '@/modules/permits/permits.routing';
import { dashboardRoutes } from '@/modules/dashboard/dashboard.routing';
import { documentsRoutes } from '@/modules/documents/documents.routing';
import { helpRoutes } from '@/modules/help/help.routing';
import { inspectionsRoutes } from '@/modules/inspections/inspections.routing';
import { homeRedirectRoutes, landingRoutes } from '@/modules/landing/landing.routing';
import { notFoundRoutes } from '@/modules/not-found/not-found.routing';
import { notificationsRoutes } from '@/modules/notifications/notifications.routing';
import { paymentsRoutes } from '@/modules/payments/payments.routing';
import { sectionRoutes } from '@/modules/sections/sections.routing';
import { settingsRoutes } from '@/modules/settings/settings.routing';

/**
 * Primary routing only: layouts, the auth boundary and one entry per module.
 * Each module's own paths and child routes live in `modules/<module>/<module>.routing.ts`,
 * and its pages are lazy-loaded there (one chunk per route).
 */
export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [landingRoutes, homeRedirectRoutes, notFoundRoutes],
  },
  {
    element: <AppLayout />,
    children: [
      helpRoutes,
      {
        element: <RequireSession />,
        children: [
          dashboardRoutes,
          applicationsRoutes,
          cashAndBillingRoutes,
          permitsRoutes,
          inspectionsRoutes,
          ...sectionRoutes,
          paymentsRoutes,
          documentsRoutes,
          accountRoutes,
          settingsRoutes,
          notificationsRoutes,
        ],
      },
    ],
  },
]);
